<template>
    <div class="teacher-page">
        <!-- 查询筛选卡片 -->
        <el-card shadow="always" class="filter-card">
            <div slot="header" class="card-header">
                <div class="card-header-left">
                    <i class="el-icon-user"></i>
                    <span>教师管理</span>
                    <el-divider direction="vertical"></el-divider>
                    <span class="header-sub">筛选条件</span>
                </div>
            </div>
            <el-form :inline="true" :model="query" class="filter-form">
                <el-form-item label="教师姓名">
                    <el-input clearable v-model="query.nickname" placeholder="请输入教师姓名" style="width: 160px"></el-input>
                </el-form-item>
                <el-form-item label="手机号">
                    <el-input clearable v-model="query.phone" placeholder="请输入手机号" style="width: 160px"></el-input>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="query.status" placeholder="全部状态" clearable style="width: 120px">
                        <el-option label="启用" :value="1"></el-option>
                        <el-option label="禁用" :value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
                    <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
                </el-form-item>
            </el-form>
        </el-card>

        <!-- 表格卡片 -->
        <el-card shadow="always" class="table-card">
            <div slot="header" class="card-header">
                <div class="card-header-left">
                    <span>数据列表</span>
                    <span class="total-badge">共 <b>{{ total }}</b> 条</span>
                </div>
                <div class="card-header-right">
                    <el-button type="primary" icon="el-icon-plus" @click="btnInsert(null)">新增教师</el-button>
                </div>
            </div>
            <el-table
                :data="list"
                border
                stripe
                v-loading="tableLoading"
                element-loading-text="加载中..."
                style="width: 100%">
                <el-table-column type="index" label="序号" width="80" align="center"/>
                <el-table-column prop="username" label="登录名" show-overflow-tooltip/>
                <el-table-column prop="nickname" label="教师姓名" show-overflow-tooltip/>
                <el-table-column prop="phone" label="手机号" show-overflow-tooltip/>
                <el-table-column prop="status" label="状态" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.status === 1 ? 'success' : 'danger'" size="small" effect="plain">
                            {{ scope.row.status === 1 ? '启用' : '禁用' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" align="center"/>
                <el-table-column align="center" label="操作" width="250" fixed="right">
                    <template slot-scope="scope">
                        <div class="action-btns">
                            <el-button type="primary" size="mini" icon="el-icon-edit" @click="btnInsert(scope.row)">编辑</el-button>
                            <el-button type="warning" size="mini" :icon="scope.row.status === 1 ? 'el-icon-close' : 'el-icon-check'"
                                @click="toggleStatus(scope.row)">
                                {{ scope.row.status === 1 ? '禁用' : '启用' }}
                            </el-button>
                            <el-button type="danger" size="mini" icon="el-icon-delete" @click="btnDelete(scope.row.id)">删除</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrapper" v-if="total > 0">
                <el-pagination
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page="query.currentPage"
                    :page-size="query.pageSize"
                    :total="total">
                </el-pagination>
            </div>
        </el-card>

        <!-- 新增/编辑对话框 -->
        <el-dialog
            :close-on-click-modal="false"
            :visible.sync="dialogVisible"
            width="600px"
            top="8vh"
            :show-close="false"
            @close="closeDialog"
            custom-class="teacher-dialog">
            <div slot="title" class="batch-header">
                <div class="batch-header-left">
                    <div class="batch-header-icon"><i class="el-icon-user-solid"></i></div>
                    <div>
                        <div class="batch-header-title">{{ dialogTitle }}</div>
                        <div class="batch-header-desc">填写教师账号信息，带 * 为必填项</div>
                    </div>
                </div>
                <i class="el-icon-close batch-header-close" @click="dialogVisible = false"></i>
            </div>
            <el-form :model="formData" ref="formData" :rules="rules" label-width="80px">
                <el-form-item label="登录名" prop="username">
                    <el-input v-model="formData.username" maxlength="11" placeholder="请输入登录名（通常为手机号）"></el-input>
                </el-form-item>
                <el-form-item label="密码" :prop="formData.id ? '' : 'password'">
                    <el-input v-model="formData.password" type="text" maxlength="20"
                        :placeholder="formData.id ? '留空则不修改密码' : '请输入密码'"
                        show-password></el-input>
                </el-form-item>
                <el-form-item label="教师姓名" prop="nickname">
                    <el-input v-model="formData.nickname" maxlength="10" placeholder="请输入教师姓名"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="phone">
                    <el-input v-model="formData.phone" maxlength="11" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item label="状态" prop="status">
                    <el-radio-group v-model="formData.status">
                        <el-radio :label="1">启用</el-radio>
                        <el-radio :label="0">禁用</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="submitForm" :loading="submitLoading">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    reqGetSysUsersById,
    reqInsertSysUsers,
    reqUpdateSysUsers,
    reqDeleteSysUsers,
    reqListSysUsers
} from '@/api/system/users'
import { reqDisableTeacher, reqEnableTeacher } from '@/api/education/teacher'

export default {
    name: 'Teacher',
    data() {
        return {
            list: [],
            total: 0,
            tableLoading: false,
            submitLoading: false,
            query: {
                roleMark: 'TEACHER',
                currentPage: 1,
                pageSize: 10,
                nickname: '',
                phone: '',
                status: null
            },
            dialogVisible: false,
            dialogTitle: '',
            formData: {
                id: null,
                username: '',
                password: '',
                nickname: '',
                phone: '',
                status: 1
            },
            rules: {
                username: [
                    { required: true, message: '请输入登录名', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { min: 6, max: 20, message: '密码长度在 6 到 20 位', trigger: 'blur' }
                ],
                nickname: [
                    { required: true, message: '请输入教师姓名', trigger: 'blur' }
                ],
                phone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
                ]
            }
        }
    },
    created() {
        this.load()
    },
    methods: {
        async load() {
            this.tableLoading = true
            try {
                const data = await reqListSysUsers(this.query)
                this.list = data.records || []
                this.total = data.total || 0
            } catch (e) {
                this.$message.error('加载教师列表失败')
                console.error(e)
            } finally {
                this.tableLoading = false
            }
        },
        handleSearch() {
            this.query.currentPage = 1
            this.load()
        },
        handleReset() {
            this.query = {
                roleMark: 'TEACHER',
                currentPage: 1,
                pageSize: 10,
                nickname: '',
                phone: '',
                status: null
            }
            this.load()
        },
        currentChange(num) {
            this.query.currentPage = num
            this.load()
        },
        sizeChange(size) {
            this.query.pageSize = size
            this.query.currentPage = 1
            this.load()
        },
        async btnInsert(row) {
            if (row) {
                this.dialogTitle = '编辑教师'
                try {
                    const data = await reqGetSysUsersById({ id: row.id })
                    this.formData = {
                        id: data.id,
                        username: data.username || '',
                        password: '',
                        nickname: data.nickname || '',
                        phone: data.phone || '',
                        status: data.status != null ? data.status : 1
                    }
                } catch (e) {
                    this.$message.error('获取教师信息失败')
                    return
                }
            } else {
                this.dialogTitle = '新增教师'
                this.formData = {
                    id: null,
                    username: '',
                    password: '',
                    nickname: '',
                    phone: '',
                    status: 1
                }
            }
            this.$nextTick(() => {
                if (this.$refs.formData) {
                    this.$refs.formData.clearValidate()
                }
            })
            this.dialogVisible = true
        },
        closeDialog() {
            this.$refs.formData && this.$refs.formData.clearValidate()
        },
        async btnDelete(id) {
            try {
                await this.$confirm('确定要删除该教师吗？删除后不可恢复。', '删除确认', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
                await reqDeleteSysUsers({ id })
                this.$message.success('删除成功')
                this.load()
            } catch (e) {
                if (e !== 'cancel') {
                    this.$message.error(e.message || '删除失败')
                }
            }
        },
        submitForm() {
            this.$refs.formData.validate(async valid => {
                if (!valid) return

                this.submitLoading = true
                try {
                    const submitData = {
                        ...this.formData,
                        roleMark: 'TEACHER'
                    }
                    if (this.formData.id) {
                        if (!submitData.password) {
                            delete submitData.password
                        }
                        await reqUpdateSysUsers(submitData)
                    } else {
                        submitData.password = submitData.password || '123456'
                        await reqInsertSysUsers(submitData)
                    }
                    this.$message.success('操作成功')
                    this.dialogVisible = false
                    this.load()
                } catch (e) {
                    this.$message.error(e.message || '操作失败')
                } finally {
                    this.submitLoading = false
                }
            })
        },
        async toggleStatus(row) {
            const newStatus = row.status === 1 ? 0 : 1
            const actionText = newStatus === 1 ? '启用' : '禁用'
            const teacherName = row.nickname || row.username || '该教师'

            try {
                await this.$confirm(`确定要${actionText}"${teacherName}"吗？`, '确认操作', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })

                if (newStatus === 0) {
                    await reqDisableTeacher(row.id)
                } else {
                    await reqEnableTeacher(row.id)
                }

                this.$message.success(`${actionText}成功`)
                this.load()
            } catch (e) {
                if (e !== 'cancel') {
                    this.$message.error(e.message || `${actionText}失败`)
                }
            }
        }
    }
}
</script>

<style scoped lang="scss">
.teacher-page {
    padding: 0;

    .filter-card {
        margin: 10px 15px;

        ::v-deep .el-card__header {
            padding: 16px 20px;
            background: #fafafa;
            border-bottom: 1px solid #ebeef5;
        }
    }

    .table-card {
        margin: 10px 15px;

        ::v-deep .el-card__header {
            padding: 14px 20px;
            background: #fafafa;
            border-bottom: 1px solid #ebeef5;
        }
    }

    .card-header {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .card-header-left {
            display: flex;
            align-items: center;
            gap: 10px;
            font-size: 15px;
            font-weight: 600;
            color: #303133;

            i {
                font-size: 18px;
                color: #409eff;
            }

            .header-sub {
                font-size: 13px;
                font-weight: 500;
                color: #909399;
            }

            .total-badge {
                font-size: 13px;
                font-weight: 400;
                color: #909399;
                margin-left: 8px;

                b {
                    color: #409eff;
                    font-size: 16px;
                    font-weight: 600;
                }
            }
        }

        .card-header-right {
            display: flex;
            align-items: center;
            gap: 10px;
        }
    }

    .filter-form {
        padding: 4px 0 0;

        ::v-deep .el-form-item {
            margin-bottom: 8px;
        }
    }

    .pagination-wrapper {
        display: flex;
        justify-content: flex-end;
        margin-top: 20px;
    }

    .action-btns {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 6px;
        white-space: nowrap;

        .el-button + .el-button {
            margin-left: 0;
        }
    }

    ::v-deep .el-divider--vertical {
        height: 1.2em;
        margin: 0 4px;
    }

    ::v-deep .el-table {
        th {
            background: #fafafa;
            color: #606266;
            font-weight: 600;
            font-size: 13px;
        }

        td {
            font-size: 13px;
        }

        .el-tag--plain {
            font-weight: 500;
        }
    }

    ::v-deep .el-dialog {
        border-radius: 6px;
        overflow: hidden;

        .el-dialog__header {
            padding: 16px 24px;
            border-bottom: 1px solid #ebeef5;

            .el-dialog__title {
                font-size: 16px;
                font-weight: 600;
                color: #303133;
            }
        }

        .el-dialog__body {
            padding: 24px 30px 8px;
        }

        .el-dialog__footer {
            padding: 14px 30px;
            border-top: 1px solid #ebeef5;
        }
    }

    ::v-deep .teacher-dialog {
        border-radius: 12px;

        .el-dialog__header {
            padding: 16px 22px;
            background: linear-gradient(135deg, #2e8b74 0%, #4fae93 100%);
            border-bottom: none;

            .el-dialog__title {
                color: #fff;
                font-size: 16px;
                font-weight: 600;
            }

            .el-dialog__headerbtn .el-dialog__close {
                color: rgba(255, 255, 255, 0.85);

                &:hover {
                    color: #fff;
                }
            }
        }

        ::v-deep .el-button--primary {
            background-color: #2e8b74;
            border-color: #2e8b74;

            &:hover, &:focus {
                background-color: #3aa98a;
                border-color: #3aa98a;
            }
        }
    }

    // ===== 弹窗自定义头部（与年级/班级一致）=====
    .batch-header {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .batch-header-left {
            display: flex;
            align-items: center;
            gap: 12px;
        }

        .batch-header-icon {
            width: 38px;
            height: 38px;
            border-radius: 10px;
            background: rgba(255, 255, 255, 0.22);
            display: flex;
            align-items: center;
            justify-content: center;

            i {
                font-size: 20px;
                color: #fff;
            }
        }

        .batch-header-title {
            font-size: 16px;
            font-weight: 600;
            color: #fff;
            line-height: 1.4;
        }

        .batch-header-desc {
            font-size: 12px;
            color: rgba(255, 255, 255, 0.85);
            margin-top: 2px;
        }

        .batch-header-close {
            font-size: 18px;
            color: rgba(255, 255, 255, 0.85);
            cursor: pointer;
            transition: all 0.2s;

            &:hover {
                color: #fff;
                transform: rotate(90deg);
            }
        }
    }
}

@media screen and (max-width: 768px) {
    .teacher-page {
        .card-header {
            flex-wrap: wrap;
            gap: 8px;
        }

        .filter-form {
            ::v-deep .el-form--inline .el-form-item {
                display: block;
                width: 100%;
                margin-bottom: 12px;
            }

            ::v-deep .el-form--inline .el-form-item .el-form-item__content {
                width: 100%;
            }

            ::v-deep .el-form--inline .el-form-item .el-form-item__content .el-select,
            ::v-deep .el-form--inline .el-form-item .el-form-item__content .el-input {
                width: 100% !important;
            }
        }

        ::v-deep .el-card__body {
            padding: 12px;
        }

        ::v-deep .el-table {
            overflow-x: auto;
            display: block;
        }

        ::v-deep .el-dialog {
            width: 95% !important;
            margin: 10px auto !important;
        }

        ::v-deep .el-dialog__body {
            padding: 16px;
        }

        ::v-deep .el-dialog__footer {
            padding: 12px 16px;
        }

        ::v-deep .el-pagination {
            white-space: normal;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            gap: 4px;
        }

        ::v-deep .el-pagination .el-pagination__total,
        ::v-deep .el-pagination .el-pagination__sizes {
            margin-right: 0;
        }

        ::v-deep .el-pagination button,
        ::v-deep .el-pagination .el-pager li {
            min-width: 28px;
            height: 28px;
            line-height: 28px;
            font-size: 12px;
        }
    }
}
</style>
